import syncFields from './_syncfields.js';
import reportModified from './_reportmodified.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import withLengthOptions from './_withlengthoptions.js';
import isInteger from '../_helpers/isinteger.js';
import assign from '../_helpers/assign.js';
// removes an item by a valid index and returns it
function removeAt(arr, index) {
  var value = arr[index];
  for (var i = index; i < arr.length - 1; i++) {
    arr[i] = arr[i + 1];
  }
  delete arr[arr.length - 1];
  arr.length -= 1;
  return value;
}
// removes an array item by index (if number is given) or by value (if object is given)
// returns the removed item or null when nothing is removed
export default function pull(toRemove, eventOptions) {
  var _this = this;
  if (eventOptions === void 0) {
    eventOptions = {};
  }
  syncFields(this);
  var typeofToRemove = typeof toRemove;
  var index;
  if (toRemove && typeofToRemove === 'object') {
    index = Array.prototype.indexOf.call(this, toRemove);
  } else if (typeofToRemove === 'number') {
    index = isInteger(toRemove) && toRemove < this.length ? toRemove : -1;
  } else {
    throw matreshkaError('pull:to_remove_type', {
      toRemove: toRemove
    });
  }
  if (index < 0) {
    return null;
  }
  var removed = withLengthOptions(this, eventOptions, function () {
    return removeAt(_this, index);
  });
  reportModified(this, assign({
    method: 'pull',
    self: this,
    added: [],
    removed: [removed]
  }, eventOptions));
  return removed;
}